module.exports = __webpack_public_path__ + "mongodb-logo.png?36d68dd4975e5cea84601b17eb7afdb1";